// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"315":"ucare-panel-chunk","923":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"294":"499e59b0","315":"b2657a2a","787":"c4e7f8f9","923":"7d5a5f4a"}[chunkId] + ".chunk.js";
};